"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _phaser = _interopRequireDefault(require("phaser"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

var ActionZone =
/*#__PURE__*/
function (_Phaser$Sprite) {
  _inherits(ActionZone, _Phaser$Sprite);

  function ActionZone(game, x, y, asset) {
    var _this;

    _classCallCheck(this, ActionZone);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ActionZone).call(this, game, x, y, 'action-zone'));
    _this.game_state = _this.game.state.states[_this.game.state.current];

    _this.game.add.existing(_assertThisInitialized(_assertThisInitialized(_this)));

    _this._addAnimations();

    _this._addBody(x, y);

    _this.anchor.set(0, 0);

    return _this;
  }

  _createClass(ActionZone, [{
    key: "_addAnimations",
    value: function _addAnimations() {
      this.animations.add('idle', [0], 1);
      this.animations.add('correct', [1, 0], 2);
      this.animations.add('incorrect', [2, 0], 2);
      this.animations.play('idle');
    }
  }, {
    key: "_addBody",
    value: function _addBody(x, y) {
      this.game.physics.p2.enable(this, DEBUG);
      this.body.fixedRotation = true;
      this.body.static = true;
      this.body.setRectangle(701, 1, 350, -32);
      this.body.setCollisionGroup(this.game_state.action_collision);
      this.body.collides(this.game_state.dna_collision);
      this.exit = new _phaser.default.Sprite(this.game, x, y + 15);
      this.game.physics.p2.enable(this.exit, DEBUG);
      this.exit.body.static = true;
      this.exit.body.setRectangle(701, 1, 350, 0);
      this.exit.body.setCollisionGroup(this.game_state.action_exit_collision);
      this.exit.body.collides(this.game_state.dna_collision);
      this.exit.body.onEndContact.add(this._onEndContact, this);
    }
  }, {
    key: "_onEndContact",
    value: function _onEndContact(hit_body) {
      if (this.game.dna != null && this.game.dna.has_c_left != this.game.dna.has_c_right) {
        this.game_state.sound_score_down.play();
        this.game.score++;
      }

      this.game.dna = null;
    }
  }]);

  return ActionZone;
}(_phaser.default.Sprite);

exports.default = ActionZone;